export const googleAnalytics = () => {
    window.dataLayer = window.dataLayer || []
    const gaID = "UA-128936172-2"
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag('js', new Date())

    gtag('config', gaID)

    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaID}`
    document.body.appendChild(script)
}